import SyncIcon from "@mui/icons-material/Sync";
import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import { ReactComponent as Logo } from "../../../vendor/logo-dark.svg";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Brand = styled(Logo)`
  width: 150px;
  height: 50px;
  margin-bottom: 20px;
`;

const LogoCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImportIcon = styled(SyncIcon)`
  font-size: 64px;
  color: #4caf50;
  animation: spin 2s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

function AmazonSuccess() {
  return (
    <React.Fragment>
      <Wrapper>
        <LogoCenter>
          <Brand />
        </LogoCenter>
        <Helmet title="Amazon Connected Successfully" />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <ImportIcon />

          <Typography component="h1" variant="h4" align="center" gutterBottom>
            We're importing your data...
          </Typography>

          <Typography
            component="h2"
            variant="body1"
            align="center"
            sx={{ color: "text.secondary", mb: 3 }}
          >
            We'll email you once it's ready (this takes a few days). You can
            close this page now.
          </Typography>

          <Button variant="contained" onClick={() => window.close()}>
            Close Page
          </Button>
        </Box>
      </Wrapper>
    </React.Fragment>
  );
}

export default AmazonSuccess;
